import { v4 as uuidv4 } from 'uuid'

export const maxWeeklySpends = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  name: `${++index * 100}`,
  __typename: 'MaxWeeklySpend'
}))
